module.exports = __webpack_public_path__ + "media/images/plans/point-c11bde358ac87661208b66146c89f8f1.svg";